import React from "react";
import { ReactSortable } from "react-sortablejs";
import "./styles.css";

const DragDrop = ({
    setDefaultOrderData,
    defaultOrderData,
    orderData,
    setOrderData,
    test,
    maxSelection,
}) => {
    return (
        <div className="flex_row justify-content_between full-width">
            <ReactSortable
                group="shared"
                animation={150}
                list={defaultOrderData}
                setList={(v) => {
                    (test.questions[0].answers.length - maxSelection <=
                        v.length ||
                        defaultOrderData.length <= v.length) &&
                        setDefaultOrderData(v);
                }}
                className="list"
            >
                {defaultOrderData.map((item) => (
                    <div className="item" key={item.position}>
                        {item.content}
                    </div>
                ))}
            </ReactSortable>
            <ReactSortable
                group="shared"
                animation={150}
                list={orderData}
                setList={(v) => {
                    (orderData.length < maxSelection ||
                        orderData.length >= v.length) &&
                        setOrderData(v);
                }}
                className="list"
            >
                {orderData.map((item) => (
                    <div
                        className="item"
                        key={item.position}
                        dangerouslySetInnerHTML={{
                            __html: item.content,
                        }}
                    />
                ))}
            </ReactSortable>
        </div>
    );
};

export default DragDrop;
